import "../../index23.css";
import { jsxs as c, jsx as t, Fragment as y } from "react/jsx-runtime";
import { useRef as u, useState as A, useEffect as E, useCallback as f, useMemo as F } from "react";
import { ArrowUpSmallFillIcon as W, ArrowDownSmallFillIcon as j } from "@ifrc-go/icons";
import { _ as m } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import U from "../Button/index.js";
import z from "../Popup/index.js";
import G from "../../contexts/dropdown-menu.js";
import H from "../../hooks/useBlurEffect.js";
const J = "_dropdown-menu_sooqs_1", K = "_dropdown-icon_sooqs_8", L = "_dropdown-content_sooqs_14", O = "_without-padding_sooqs_19", n = {
  dropdownMenu: J,
  dropdownIcon: K,
  dropdownContent: L,
  withoutPadding: O
};
function ro(w) {
  const h = u(null), {
    className: _,
    activeClassName: C,
    children: b,
    label: g,
    labelBefore: P,
    labelAfter: l,
    labelSpacing: R,
    labelColorVariant: I,
    labelStyleVariant: M,
    labelWithoutPadding: N,
    withoutDropdownIcon: s,
    componentRef: r,
    elementRef: a = h,
    persistent: i,
    popupClassName: D,
    preferredPopupWidth: S,
    withoutPopupPadding: v
  } = w, p = u(null), [e, o] = A(!1);
  E(() => {
    r && (r.current = {
      setShowDropdown: o
    });
  }, [r, o]);
  const x = f(
    () => {
      o((d) => !d);
    },
    [o]
  ), B = f(
    (d, q) => {
      q || d && i || o(!1);
    },
    [o, i]
  );
  H(
    e,
    B,
    p,
    a
  );
  const V = F(
    () => ({
      setShowDropdown: o
    }),
    [o]
  ), k = !!l || !s;
  return /* @__PURE__ */ c(G.Provider, { value: V, children: [
    /* @__PURE__ */ t(
      U,
      {
        name: void 0,
        className: m(
          n.dropdownMenu,
          e && C,
          _
        ),
        layoutElementRef: a,
        onClick: x,
        styleVariant: M,
        colorVariant: I,
        withoutPadding: N,
        spacing: R,
        after: k ? /* @__PURE__ */ c(y, { children: [
          l,
          !s && (e ? /* @__PURE__ */ t(W, { className: n.dropdownIcon }) : /* @__PURE__ */ t(j, { className: n.dropdownIcon }))
        ] }) : void 0,
        before: P,
        children: g
      }
    ),
    e && /* @__PURE__ */ t(
      z,
      {
        elementRef: p,
        className: m(
          n.dropdownContent,
          v && n.withoutPadding,
          D
        ),
        parentRef: a,
        preferredWidth: S,
        children: b
      }
    )
  ] });
}
export {
  ro as default
};
